// Lib
import PropTypes from 'prop-types';

// Selectors
import { getIsSwiftHybrid } from '../../hybridApp/hybridAppUtils';

/**
 * Hide the children if we're running on the mobile hybrid app (iPad app).
 */
const SwiftHybridHidden = ({ children, fallback = null }) => (getIsSwiftHybrid() ? fallback : children);

SwiftHybridHidden.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    fallback: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default SwiftHybridHidden;
